import { render, staticRenderFns } from "./EXEmptyState.vue?vue&type=template&id=5fb99dc6&scoped=true"
import script from "./EXEmptyState.vue?vue&type=script&setup=true&lang=js"
export * from "./EXEmptyState.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EXEmptyState.vue?vue&type=style&index=0&id=5fb99dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb99dc6",
  null
  
)

export default component.exports